import {
  hasTrackedAdditionalAttributionInSession,
  markAdditionalAttributionAsTrackedInSession
} from './additionalAttributionDedup';

export interface TopsortAdsContext {
  bidId: string;
  landingPath: string;
}

export const normalizePathname = (path = ''): string => {
  if (!path) return '/';
  const normalized = path.replace(/\/+$/, '');
  return normalized || '/';
};

export const parseTopsortAdsContext = (
  cookieValue: unknown
): TopsortAdsContext | null => {
  if (typeof cookieValue !== 'string' || !cookieValue) {
    return null;
  }

  const parsedCookie = JSON.parse(cookieValue) as TopsortAdsContext;

  if (!parsedCookie?.bidId || !parsedCookie?.landingPath) {
    return null;
  }

  return parsedCookie;
};

export const getTopsortAdsContextFromCookie = ({
  cookieValue,
  loggerContext,
  logError
}: {
  cookieValue: unknown;
  loggerContext: string;
  logError: (
    payload: { message: string; data: string },
    context: string
  ) => void;
}): TopsortAdsContext | null => {
  if (!cookieValue) {
    return null;
  }

  try {
    return parseTopsortAdsContext(cookieValue);
  } catch (error) {
    logError(
      {
        message: 'Unable to get cookie data for Topsort click event or send event',
        data: JSON.stringify({
          error: {
            message: error instanceof Error ? error.message : String(error),
            stack: error instanceof Error ? error.stack : undefined
          }
        })
      },
      loggerContext
    );

    return null;
  }
};

export const isAdsLandingPathMatch = (
  landingPath: string,
  currentPathname: string
): boolean => {
  return normalizePathname(landingPath) === normalizePathname(currentPathname);
};

export const createAdditionalAttributionImpressionKey = ({
  bidId,
  landingPath,
  productId
}: {
  bidId: string;
  landingPath: string;
  productId: string;
}): string => {
  return `${bidId}:${normalizePathname(landingPath)}:${productId}`;
};

export const shouldTrackAdditionalAttributionImpression = ({
  impressionKey,
  trackedKeys
}: {
  impressionKey: string;
  trackedKeys: Set<string>;
}): boolean => {
  if (
    trackedKeys.has(impressionKey) ||
    hasTrackedAdditionalAttributionInSession(impressionKey)
  ) {
    trackedKeys.add(impressionKey);
    return false;
  }

  trackedKeys.add(impressionKey);
  markAdditionalAttributionAsTrackedInSession(impressionKey);

  return true;
};
